import React, { createContext, useState, useContext, useMemo } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);

  // MODIFICADO: Acepta 'quantityToAdd'
  const addToCart = (product, quantityToAdd) => {
    if (quantityToAdd <= 0) return; // No hacer nada si la cantidad es 0 o menos

    setCartItems(prevItems => {
      // 1. Revisa si el item ya está en el carrito
      const existingItem = prevItems.find(item => item.id_product === product.id_product);

      if (existingItem) {
        // 2. Si existe, actualiza la cantidad
        return prevItems.map(item =>
          item.id_product === product.id_product
            ? { ...item, quantity: item.quantity + quantityToAdd }
            : item
        );
      } else {
        // 3. Si es nuevo, lo agrega con la cantidad especificada
        return [...prevItems, { ...product, quantity: quantityToAdd }];
      }
    });
  };

  const removeFromCart = (productId) => {
    setCartItems(prevItems => {
      return prevItems.filter(item => item.id_product !== productId);
    });
  };

  // Lógica para calcular el subtotal (usamos useMemo para eficiencia)
  const subtotal = useMemo(() => {
    return cartItems.reduce((acc, item) => acc + (item.price * item.quantity), 0);
  }, [cartItems]);

  const value = {
    cartItems,
    addToCart,
    removeFromCart,
    subtotal
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart debe ser usado dentro de un CartProvider');
  }
  return context;
};